import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import style from './markdown.module.css';

interface MarkdownProps {
  content: string;
}

export const Markdown: FC<MarkdownProps> = ({ content }) => {
  return (
    <div className="markdown-container" data-testid={DataTestIdEnum.MARKDOWN_CONTAINER}>
      <ReactMarkdown className={style['markdown-container']} rehypePlugins={[rehypeRaw]}>
        {content}
      </ReactMarkdown>
    </div>
  );
};
